(($, Drupal) => {
  Drupal.behaviors.tariffsTabs = {
    attach: function attach() {
      $('.tariffs__tabs-item').once('add').on('click', function () {
        const el = $(this);
        const elCategory = el.data('tab');

        if (el.hasClass('active')) {
          return;
        }

        $('.tariffs__tabs-item.active').removeClass('active');
        el.addClass('active');

        $('.tariffs__content.active').removeClass('active');
        $(`.tariffs__content[data-category="${elCategory}"]`).addClass('active');
      });
    },
  };
})(jQuery, Drupal);
